import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PageLoader } from "../components/PageLoader";
import { ROUTES } from "../config/routes";

export const SubscriptionCancel = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth0();

    useEffect(() => {
        // Automatically redirect to dashboard with SETUP->subscriptions subtab
        // Include from=stripe parameter to trigger welcome back toast
        // TODO: Update to use ROUTES.DASHBOARD_PROFILE_SUBSCRIPTIONS once Dashboard is refactored
        if (isAuthenticated) {
            navigate(`${ROUTES.DASHBOARD}?tab=setup&subtab=subscriptions&from=stripe`);
        }
    }, [isAuthenticated, navigate]);

    // Show loader while redirecting
    return <PageLoader />;
};

export default withAuthenticationRequired(SubscriptionCancel, {
    onRedirecting: () => <PageLoader />,
});
